import { CheckCircle2, Clock, Loader2, Slash, XCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { JobStatus } from '@/shared/api/types';
import { cn } from '@/shared/lib/cn';
import { Badge } from './Badge';

const CONFIG: Record<JobStatus, { tone: 'neutral' | 'info' | 'success' | 'danger'; icon: React.ReactNode }> = {
  pending: { tone: 'neutral', icon: <Clock className="h-3 w-3" /> },
  running: { tone: 'info', icon: <Loader2 className="h-3 w-3 animate-spin" /> },
  completed: { tone: 'success', icon: <CheckCircle2 className="h-3 w-3" /> },
  failed: { tone: 'danger', icon: <XCircle className="h-3 w-3" /> },
  cancelled: { tone: 'neutral', icon: <Slash className="h-3 w-3" /> },
};

/** One status vocabulary for every kind of work in the product. */
export function JobStatusBadge({ status, className }: { status: JobStatus; className?: string }) {
  const { t } = useTranslation();
  const config = CONFIG[status] ?? CONFIG.pending;
  return (
    // `shrink-0`: this sits next to a `min-w-0` title/text column in every caller (the Job Tray,
    // project cards). `Badge`'s own overflow-hidden + text-ellipsis gives it an implicit
    // min-width of 0 as a flex item, so without this a long sibling squeezes the badge itself
    // down first — "Hoàn thành" clipped to "Hoàn" — instead of the title column absorbing it.
    <Badge tone={config.tone} icon={config.icon} className={cn('shrink-0', className)}>
      {t(`jobs.status.${status}`)}
    </Badge>
  );
}
